import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { initialize } from './actions/piano';
import { getCustomize } from './actions/customize';

import Index from './pages/Index';
import Closed from './pages/Closed';
import Prepair from './pages/Prepair';
import Logout from './pages/Logout';
import MyPage from './pages/MyPage';
import ConfirmVideo from './pages/ConfirmVideo';

import Offer from './pages/OfferPage';

import PrivacyPolicy from './pages/PrivacyPolicy';
import PersonalInformation from './pages/PersonalInformation';
import SpecifiedCommercialTransactionAct from './pages/SpecifiedCommercialTransactionAct';
import TermOfService from './pages/TermOfService';
import Faq from './pages/Faq';

import MobileMenu from './components/MobileMenu/MobileMenu';
import ScrollToTop from './components/Header/ScrollToTop';
import NotFound from './pages/NotFound';
import InternalServerError from './pages/InternalServerError';
import Guide from './pages/Guide';
import Refund from './pages/Refund';
import Unsubscribe from './pages/Unsubscribe';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

function App(props) {
	//let [indexPage, setIndexPage] = useState(0);
	let indexPage = ''
	if (process.env.REACT_APP_SITE_STATUS === 'prepair') indexPage = Prepair
	if (process.env.REACT_APP_SITE_STATUS === 'open') indexPage = Index
	if (process.env.REACT_APP_SITE_STATUS === 'close') indexPage = Closed

	useEffect(() => {
		props.initialize();
		props.customize(process.env.REACT_APP_DISTRIBUTORS_NAME);
	}, []);

	return (
		<React.Fragment>
			<div className={`${props.isStreaming ? 'detail-live' : ''}`}>
				{
					<Router>
						<ScrollToTop />
						<Header />
						<div className="container">
							<Switch>
								<Route exact path="/" component={indexPage} />
								<Route exact path="/logout" component={Logout} />
								<Route exact path="/mypage" component={MyPage} />
								<Route path="/offer/:offer_id" component={Offer} />

								<Route exact path="/privacy_policy" component={PrivacyPolicy} />
								<Route exact path="/personal_information" component={PersonalInformation} />
								<Route exact path="/specified_commercial_transaction_law" component={SpecifiedCommercialTransactionAct} />
								<Route exact path="/term_of_service" component={TermOfService} />
								<Route exact path="/faq" component={Faq} />

								<Route exact path="/confirm" component={ConfirmVideo} />
								<Route exact path="/test" component={ConfirmVideo} />
								<Route exact path="/500" component={InternalServerError} />
								<Route exact path="/404" component={NotFound} />
								<Route exact path="/guide" component={Guide} />
								<Route exact path="/refund" component={Refund} />
								<Route exact path="/unsubscribe" component={Unsubscribe} />
								<Route component={NotFound} />
							</Switch>
						</div>
						<Footer />
						<MobileMenu />
					</Router>
				}
			</div>
		</React.Fragment>
	);
}

const mapStateToProps = state => {
	return {
		language: state.piano.language,
		isStreaming: state.offer.isStreaming,
		donePageLoading: state.offer.donePageLoading,
	};
};

const mapDispatchToProps = dispatch => ({
	initialize: () => dispatch(initialize()),
	customize: (distributorId) => dispatch(getCustomize(distributorId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
